import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Card } from 'react-bootstrap';
import { getPaymentLogs, getLookupByGroup } from '../../services/adminApi'; 
import './AdminPaymentsLog.css';
import PaymentLogsFilter from './payment/components/PaymentLogsFilter';
import PaymentLogsTable from './payment/components/PaymentLogsTable';

const AdminPaymentLogs = () => {
    const navigate = useNavigate();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('All Statuses');
    const [gatewayFilter, setGatewayFilter] = useState('All Gateways');
    const [dateRange, setDateRange] = useState('');
    const [gatewayOptions, setGatewayOptions] = useState([]);

    useEffect(() => {
        const fetchGateways = async () => {
            try {
                const res = await getLookupByGroup("paymentGateway");
                const list = res?.data?.data || res?.data || [];
                if (Array.isArray(list)) {
                    setGatewayOptions(list.map(i => ({
                        value: i.lookupValue || i.value || i.key,
                        label: i.lookupLabel || i.label || i.value || i.lookupValue
                    })));
                }
            } catch (err) {
                console.error("Could not fetch payment gateway lookups", err);
            }
        };
        fetchGateways();
    }, []);

    const fetchLogs = async () => {
        setLoading(true);
        try {
            const params = {
                search: search,
                status: statusFilter === 'All Statuses' ? undefined : statusFilter,
                gateway: gatewayFilter === 'All Gateways' ? undefined : gatewayFilter
            };
            const response = await getPaymentLogs(params);
            setLogs(response.data.data || []);
        } catch (err) {
            console.error('Could not load payment logs.', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchLogs();
        }, 300);
        return () => clearTimeout(delayDebounce);
    }, [search, statusFilter, gatewayFilter]);

    return (
        <div className="container-fluid py-4 admin-payments-container">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 className="admin-payments-title">Payment Transactions</h2>
                    <p className="admin-payments-subtitle">Review and audit booking payment status logs</p>
                </div>
                <Badge bg="danger" className="px-3 py-2 fs-6 rounded-pill">Total logs: {logs.length}</Badge>
            </div>

            <Card className="border-0 rounded-4 overflow-hidden mb-4 admin-payments-card">
                <PaymentLogsFilter
                    search={search}
                    setSearch={setSearch}
                    statusFilter={statusFilter}
                    setStatusFilter={setStatusFilter}
                    gatewayFilter={gatewayFilter}
                    setGatewayFilter={setGatewayFilter}
                    gatewayOptions={gatewayOptions}
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                />
                <PaymentLogsTable
                    logs={logs}
                    loading={loading}
                    navigate={navigate}
                />
            </Card>
        </div>
    );
};

export default AdminPaymentLogs;